export default __webpack_public_path__ + "c54def2f1a3bf09d11aea4ec2c340c25.svg";